import { createStyles, makeStyles } from '@mui/styles';
import IRANSans from "../assets/fonts/IRANSans.ttf";

const useGlobalStyles = makeStyles(() =>
    createStyles({
        "@global": {
            "@font-face": [
                {
                    fontFamily: "IRANSans",
                    fontStyle: "normal",
                    src: `url(${IRANSans})`,
                },
            ],
            body: {
            fontSize: "13px",
            fontFamily: "IRANSans",
            },
        },
    })
);

export default useGlobalStyles;